import {
  Box,
  Flex,
  Icon,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { ImagePlaylistTypeIllustration } from '~components/ui/illustrations/ImagePlaylistTypeIllustration';
import { MixedPlaylistTypeIllustration } from '~components/ui/illustrations/MixedPlaylistTypeIllustration';
import { PlaylistCreateInput, PlaylistType } from '~graphql/__generated__/types';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (value: PlaylistCreateInput['playlistType']) => void;
}

export function SelectPlaylistTypeModal({ isOpen, onClose, onSelect }: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="2xl"
      closeOnOverlayClick={false}
      closeOnEsc={true}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('selectPlaylistType')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            {/* Single Display Claim */}
            <Box
              as="button"
              onClick={() => onSelect(PlaylistType.Mixed)}
              w="100%"
              p={4}
              borderRadius="xl"
              bg="#F1F8FE"
              _hover={{ bg: 'blue.100' }}
              textAlign="left"
            >
              <Flex align="center">
                <Box mr={8}>
                  <Icon as={MixedPlaylistTypeIllustration} boxSize={36} color="blue.500" />
                </Box>
                <Box>
                  <Text mb={4} fontWeight="bold" fontSize="lg">
                    {t('imagesVideos')}
                  </Text>
                  <Text mb={4} fontSize="sm" color="gray.600">
                    <Trans i18nKey="imagesVideosDesc" components={{ strong: <strong /> }} />
                  </Text>
                  <Text fontSize="sm" color={'gray.600'}>
                    {t('pleaseRefer')}{' '}
                    <Link
                      color="blue.500"
                      href="https://www.ppds.com"
                      isExternal
                      onClick={(e) => e.stopPropagation()}
                      textDecoration="underline"
                    >
                      {t('wwwppdscom')}
                    </Link>{' '}
                    {t('moreDetails')}
                  </Text>
                </Box>
              </Flex>
            </Box>

            {/* Bulk Display Claim */}
            <Box
              as="button"
              onClick={() => onSelect(PlaylistType.Image)}
              w="100%"
              p={4}
              borderRadius="xl"
              bg={'#F1F8FE'}
              color={'black'}
              _hover={{ bg: 'blue.100' }}
              textAlign="left"
              position="relative"
            >
              <Box
                position="absolute"
                top={3}
                right={0}
                bg="red.300"
                color="white"
                px={3}
                fontSize="xs"
                fontWeight="bold"
                borderTopLeftRadius="xl"
                borderBottomLeftRadius="xl"
              >
                {t('noVideoContent')}
              </Box>
              <Flex align="center">
                <Box mr={8}>
                  <Icon as={ImagePlaylistTypeIllustration} boxSize={36} color="green.500" />
                </Box>
                <Box>
                  <Text mb={4} fontWeight="bold" fontSize="lg">
                    {t('imagesOnly')}
                  </Text>
                  <Text mb={4} fontSize="sm" color={'gray.600'}>
                    <Trans i18nKey="imagesOnlyDesc1" components={{ strong: <strong /> }} />{' '}
                  </Text>
                  <Text fontSize="sm" color={'gray.600'}>
                    {t('pleaseRefer')}{' '}
                    <Link
                      color="blue.500"
                      href="https://www.ppds.com"
                      isExternal
                      onClick={(e) => e.stopPropagation()}
                      textDecoration="underline"
                    >
                      {t('wwwppdscom')}
                    </Link>{' '}
                    {t('moreDetails')}
                  </Text>
                </Box>
              </Flex>
            </Box>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
